import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Dialog, Grid, Button, TextField, Switch } from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import instance from "../../../request/http";
import { BASE_URL } from "../../../store/config";
import { getToday, format2ToTimestamp, timeFormat2, timeFormatS } from '../../../common/utils';
import UserAutoComplete from '../../Components/UserAutoComplete';
import Toast from "../../Layout/components/Toast";
import { ADD, EDIT } from '../../../common/common';


const Root = styled(Dialog)({
    width: '100%',
    '& .MuiGrid-item': {
        padding: '4px 12px'
    }
})

class NormalEditor extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: null,
            open: false,
            data: {
                date: getToday(),
                desc: "",
                amount: 0,
            },
            enable: true,
            showToast: false,
            toastMsg: "",
            toastState: "",
        };

        this.handleClose = this.handleClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleAlias = this.handleAlias.bind(this);
        this.updateHandler = this.updateHandler.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
    }

    render() {
        const {
            open,
            data,
            showToast,
            toastMsg,
            toastState,
        } = this.state,
            {
                isAdd,
                type,
                amountAvailable
            } = this.props,
            showTitle = () => {
                if (isAdd) {
                    return <span>NEW {this.changeTitle(this.props.type)}</span>
                }
                return <span>EDIT {this.changeTitle(this.props.type)}</span>
            },
            dateView = () => {
                if (type === "deposite") {
                    return <TextField
                        variant="outlined"
                        label="Date"
                        className="textField"
                        value={data.date}
                        margin="dense"
                        fullWidth
                        disabled={true}
                    />
                } else {
                    return <TextField
                        type="date"
                        variant="outlined"
                        label="Date"
                        className="textField"
                        name="date"
                        value={data.date}
                        margin="dense"
                        fullWidth
                        onChange={e => this.handleChange(e)}
                    />
                }
            };

        return <Root open={open} onClose={this.handleClose} aria-labelledby="form-dialog-title" className="editor">
            <DialogTitle id="form-dialog-title">
                <div className="editor-title">{showTitle()}</div>
            </DialogTitle>
            <DialogContent dividers spacing={3}>
                <Grid container>
                    <Grid item xs={12} sm={6}>
                        {dateView()}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            variant="outlined"
                            margin="dense"
                            label="Amount"
                            type="number"
                            name="amount"
                            helperText={type === "deposite" ? ("Amount Available: $" + amountAvailable) : ""}
                            value={data.amount}
                            fullWidth
                            onChange={e => this.handleChange(e)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <TextField
                            variant="outlined"
                            margin="dense"
                            label="Description"
                            type="text"
                            name="desc"
                            value={data.desc}
                            multiline
                            rows="4"
                            fullWidth
                            onChange={e => this.handleChange(e)}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => this.handleClose()}>
                    Cancel
                </Button>
                <Button onClick={() => this.handleClose(isAdd ? ADD : EDIT)} variant="contained" color="primary">
                    Save
                </Button>
            </DialogActions>
            <Toast
                open={showToast}
                msg={toastMsg}
                state={toastState}
                handleClose={this.handleCloseToast}
            ></Toast>
        </Root>

    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps) {
        const {
            open,
            itemId: id,
            item,
        } = this.props;
        if (prevProps.open !== open) {
            if (open) {
                this.initEditor(id, item);
            } else {
                this.setState({
                    open
                });
            }
        }
    }

    initEditor(id, item) {
        const {
            isAdd,
            type
        } = this.props;
        console.log("sss", this.props.type, this.props.helperText)
        let date = "";
        if (type === "deposite") {
            date = isAdd ? timeFormatS() : timeFormatS(item.date);
        } else {
            date = isAdd ? getToday() : timeFormat2(item.date)
        }
        this.setState({
            open: true,
            data: {
                date,
                desc: isAdd ? "" : item.description,
                amount: isAdd ? 0 : item.amount || 0,
                id: isAdd ? -1 : item.id
            }
        });
    }

    handleClose(status) {
        const { onClose } = this.props;
        if (typeof onClose !== 'function') {
            console.error("onClose is not a function");
            return
        }
        if (status !== null && status !== undefined) {
            const { data } = this.state;
            const params = {
                date: format2ToTimestamp(data.date),
                description: data.desc,
                amount: data.amount,
            };
            if (status === ADD) {
                this.addData(params, (id) => {
                    onClose(ADD, id);
                })
            } else {
                this.editData(data.id, params, () => {
                    onClose(EDIT);
                });
            }
        } else {
            onClose();
        }
    }

    handleChange(e) {
        const { amountAvailable } = this.props;
        const { value, name } = e.target;
        console.log(value, name);

        this.setState((prevState) => ({
            data: {
                ...prevState.data,
                [name]: value
            }
        }));
    }

    handleAlias(event) {
        const isChecked = event.target.checked;
        this.setState((prevState) => ({
            data: {
                ...prevState.data,
                enableAlias: isChecked,
            }
        }));
    }

    updateHandler(handler) {
        if (!handler) return;
        this.setState((prevState) => ({
            data: {
                ...prevState.data,
                handler: handler,
            }
        }));
    }

    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }

    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    
    changeTitle(type) {
        if (type === "prepayment") {
            return "LEGAL FEE";
        } else if (type === "payment") {
            return "PAYMENT";
        }
    }

    // todo: this api doesn't exist
    getLegalFee(id) {
        instance.get(BASE_URL + 'billing/legal_fee/' + id, {}).then((res) => {
            console.log(res);
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }

    addData(params, callback = null) {
        instance.post(BASE_URL + 'billing/' + this.props.type, params).then((res) => {
            const id = res.data.data.id;
            console.log("iddddd", id)
            if (callback) callback(id);
        }).catch((err) => {
            // const msg = err.response.data.message;
            // this.showToast(msg, "error");
        })
    }
    editData(id, params, callback = null) {
        instance.put(BASE_URL + 'billing/' + this.props.type + '/' + id, params).then((res) => {
            // this.showToast("Successfully modified", "success");
            if (callback) callback();
        }).catch((err) => {
            // const msg = err.response.data.message;
            // this.showToast(msg, "error");
        })
    }

    saveLegalFee(id, params, callback) {
        instance.put(BASE_URL + 'billing/legal_fee/' + id, params).then((res) => {
            // this.showToast("Successfully modified", "success");
            callback();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        });
    }

}

export default NormalEditor;